import { animateIfVisible, handleIfCompletelyHidden } from './animate-bar'

export const initializeBarDiagram = (diagram, diagramType, highlight, highlightValue, decimals, locale) => {
  const maximumBarLength = diagramType == 'vertical' ? 200 : diagram.clientWidth * 0.7

  const bars = diagram.querySelectorAll('.diagram-bar')
  let maximumValue = initializeBarsAndFindMaximumValue(bars)

  if (diagramType == 'horizontal') {
    const names = diagram.querySelectorAll('.diagram-name')
    findWidestNameAndAdaptOtherNamesToFitWidth(names)
  }

  const callback = (entries) => {
    animateBasedOnIntersectionRatio(entries, highlight, bars, diagramType, maximumBarLength, maximumValue, highlightValue, decimals, locale)
  }

  const observer = new IntersectionObserver(callback, { threshold: [0, 0.75] })
  observer.observe(diagram)
}

const initializeBarsAndFindMaximumValue = (bars) => {
  let maxValue = 0

  if (!bars || bars.length === 0) return maxValue

  let lastBar = bars[bars.length - 1]
  lastBar.style.backgroundColor = '#000000'
  bars.forEach((bar, idx) => {
    const itemJSON = JSON.parse(bar.dataset.item)
    initializeSingleBar(bar, itemJSON, idx)

    if (parseFloat(itemJSON.value) > maxValue) maxValue = parseFloat(itemJSON.value)
  })

  return maxValue
}

const findWidestNameAndAdaptOtherNamesToFitWidth = (names) => {
  const maxWidth = Math.max(...Array.from(names)
    .map(element => parseFloat(window.getComputedStyle(element).width)
    ))

  names.forEach(div => div.style.width = `${maxWidth}px`)
}

const initializeSingleBar = (bar, itemJSON, idx) => {
  if (!!itemJSON.color) bar.style.backgroundColor = itemJSON.color
  bar.style.transitionDelay = idx * 0.5 + 's'
}

const animateBasedOnIntersectionRatio = (entries, highlight, bars, diagramType, maximumBarLength, maxValue, highlightValue, decimals, locale) => {
  if (!entries || !entries[0]) return

  const entry = entries[0]
  if (entry.isIntersecting && entry.intersectionRatio >= 0.75 && !(highlight && highlight.innerText != 0)) {
    animateIfVisible(bars, diagramType, maximumBarLength, maxValue, highlight, highlightValue, decimals, locale)
  } else if (entry.intersectionRatio == 0) {
    handleIfCompletelyHidden(highlight, bars, diagramType)
  }
}
